import script from "./LTagColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./LTagColor.vue?vue&type=script&setup=true&lang=ts"

import "./LTagColor.vue?vue&type=style&index=0&id=5a07eadf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a07eadf"]])

export default __exports__